import { useEffect, useState } from 'react'

export interface Countdown {
  days: number
  hours: number
  minutes: number
  seconds: number
}

export const SALDERING_END = new Date('2027-01-01T00:00:00+01:00')

function diff(target: Date): Countdown {
  const ms = Math.max(0, target.getTime() - Date.now())
  return {
    days: Math.floor(ms / 86400000),
    hours: Math.floor((ms / 3600000) % 24),
    minutes: Math.floor((ms / 60000) % 60),
    seconds: Math.floor((ms / 1000) % 60),
  }
}

export function useCountdown(target: Date = SALDERING_END): Countdown {
  const [value, setValue] = useState(() => diff(target))
  useEffect(() => {
    const id = window.setInterval(() => setValue(diff(target)), 1000)
    return () => window.clearInterval(id)
  }, [target])
  return value
}
